"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanBillingCycleData = exports.getPlanShortName = exports.getPlanName = exports.PlanIdTypes = exports.PlanShortNameTypes = exports.PlanTypes = void 0;
var PlanTypes;
(function (PlanTypes) {
    PlanTypes["FREE"] = "Plan Free";
    PlanTypes["LITE"] = "Plan Lite";
    PlanTypes["LITE_SMS"] = "Plan Lite SMS";
    PlanTypes["PRO"] = "Plan Pro";
    PlanTypes["PREMIUM"] = "Plan Premium";
    PlanTypes["PRO_SMS"] = "Plan Pro SMS";
    PlanTypes["PRO_START"] = "Plan Start Pro";
    PlanTypes["TRIAL"] = "Plan Trial";
})(PlanTypes = exports.PlanTypes || (exports.PlanTypes = {}));
var PlanShortNameTypes;
(function (PlanShortNameTypes) {
    PlanShortNameTypes["FREE"] = "Free";
    PlanShortNameTypes["LITE"] = "Lite";
    PlanShortNameTypes["LITE_SMS"] = "Lite SMS";
    PlanShortNameTypes["PRO"] = "Pro";
    PlanShortNameTypes["PREMIUM"] = "Premium";
    PlanShortNameTypes["PRO_SMS"] = "Pro SMS";
    PlanShortNameTypes["PRO_START"] = "Start Pro";
    PlanShortNameTypes["TRIAL"] = "Trial";
})(PlanShortNameTypes = exports.PlanShortNameTypes || (exports.PlanShortNameTypes = {}));
var PlanIdTypes;
(function (PlanIdTypes) {
    PlanIdTypes["PREMIUM_ORGANIZATION"] = "655cd2a5-cb0b-4469-a288-5d2826ca7494";
    PlanIdTypes["PREMIUM_ORGANIZATION_30"] = "641c858d-750e-4133-bd24-2ec92d3ca915";
    PlanIdTypes["PRO_LEGACY"] = "700ef752-d911-4f33-91fd-cc050a99a768";
    PlanIdTypes["PRO"] = "8d4994f4-b2df-484e-8bce-931a66d2cb0c";
    PlanIdTypes["PRO_ORGANIZATION"] = "0b13b889-21b0-4a03-9f21-3b8f1286e269";
    PlanIdTypes["PRO_ORGANIZATION_14"] = "dcadbc28-98e1-482b-8c2b-644551d7281a";
    PlanIdTypes["PRO_ORGANIZATION_30"] = "6ea69506-629b-4d53-94e7-9edbbd5d2a19";
    PlanIdTypes["TRIAL"] = "879d8aed-f430-494f-8fa5-4521a2c54495";
    PlanIdTypes["PRO_SMS_ORGANIZATION_LEGACY"] = "33291f17-3275-4ede-ae81-b4c13a96fc69";
    PlanIdTypes["PRO_SMS_ORGANIZATION_14"] = "315be71e-a11a-4c89-a720-f021f767b6c0";
    PlanIdTypes["PRO_SMS_ORGANIZATION_30"] = "4c188a56-12b7-43be-a39b-c5fa8dcdf42b";
    PlanIdTypes["PRO_SMS_ORGANIZATION"] = "71b02080-c2ea-42c7-a875-686f41fbb273";
    PlanIdTypes["PRO_START_ORGANIZATION"] = "8c866bbf-b998-4488-bd47-1005cbebf5f1";
    PlanIdTypes["FREE_ORGANIZATION"] = "103ef36a-769b-440a-92b1-b058eadfc489";
    PlanIdTypes["FREE_PRIVATE"] = "22492df6-1697-489f-8a84-052fd8e46ec8";
    PlanIdTypes["FREE_0"] = "5189ec3d-615e-4a36-962a-661057c13a01";
    PlanIdTypes["LITE_ORGANIZATION"] = "39c883b5-9913-4d01-9013-cf48bf49a89f";
    PlanIdTypes["LITE_SMS_ORGANIZATION"] = "82d56449-ee68-4d01-8f56-02936e192362";
})(PlanIdTypes = exports.PlanIdTypes || (exports.PlanIdTypes = {}));
var getPlanName = function (planId) {
    switch (planId) {
        case PlanIdTypes.FREE_ORGANIZATION:
        case PlanIdTypes.FREE_PRIVATE:
        case PlanIdTypes.FREE_0:
            return PlanTypes.FREE;
        case PlanIdTypes.LITE_ORGANIZATION:
            return PlanTypes.LITE;
        case PlanIdTypes.LITE_SMS_ORGANIZATION:
            return PlanTypes.LITE_SMS;
        case PlanIdTypes.PRO:
        case PlanIdTypes.PRO_LEGACY:
        case PlanIdTypes.PRO_ORGANIZATION:
        case PlanIdTypes.PRO_ORGANIZATION_14:
        case PlanIdTypes.PRO_ORGANIZATION_30:
            return PlanTypes.PRO;
        case PlanIdTypes.PRO_SMS_ORGANIZATION_LEGACY:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_14:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_30:
        case PlanIdTypes.PRO_SMS_ORGANIZATION:
            return PlanTypes.PRO_SMS;
        case PlanIdTypes.PRO_START_ORGANIZATION:
            return PlanTypes.PRO_START;
        case PlanIdTypes.PREMIUM_ORGANIZATION:
        case PlanIdTypes.PREMIUM_ORGANIZATION_30:
            return PlanTypes.PREMIUM;
        case PlanIdTypes.TRIAL:
            return PlanTypes.TRIAL;
        default:
            var exhaustiveCheck = planId;
            return null;
    }
};
exports.getPlanName = getPlanName;
var getPlanShortName = function (planId) {
    switch (planId) {
        case PlanIdTypes.FREE_ORGANIZATION:
        case PlanIdTypes.FREE_PRIVATE:
        case PlanIdTypes.FREE_0:
            return PlanShortNameTypes.FREE;
        case PlanIdTypes.LITE_ORGANIZATION:
            return PlanShortNameTypes.LITE;
        case PlanIdTypes.LITE_SMS_ORGANIZATION:
            return PlanShortNameTypes.LITE_SMS;
        case PlanIdTypes.PRO:
        case PlanIdTypes.PRO_LEGACY:
        case PlanIdTypes.PRO_ORGANIZATION:
        case PlanIdTypes.PRO_ORGANIZATION_14:
        case PlanIdTypes.PRO_ORGANIZATION_30:
            return PlanShortNameTypes.PRO;
        case PlanIdTypes.PRO_SMS_ORGANIZATION_LEGACY:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_14:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_30:
        case PlanIdTypes.PRO_SMS_ORGANIZATION:
            return PlanShortNameTypes.PRO_SMS;
        case PlanIdTypes.PRO_START_ORGANIZATION:
            return PlanShortNameTypes.PRO_START;
        case PlanIdTypes.PREMIUM_ORGANIZATION:
        case PlanIdTypes.PREMIUM_ORGANIZATION_30:
            return PlanShortNameTypes.PREMIUM;
        case PlanIdTypes.TRIAL:
            return PlanShortNameTypes.TRIAL;
        default:
            var exhaustiveCheck = planId;
            return null;
    }
};
exports.getPlanShortName = getPlanShortName;
var getPlanBillingCycleData = function (planId) {
    switch (planId) {
        case PlanIdTypes.FREE_ORGANIZATION:
        case PlanIdTypes.FREE_PRIVATE:
        case PlanIdTypes.FREE_0:
        case PlanIdTypes.LITE_ORGANIZATION:
        case PlanIdTypes.LITE_SMS_ORGANIZATION:
        case PlanIdTypes.PRO:
        case PlanIdTypes.PRO_LEGACY:
        case PlanIdTypes.PRO_ORGANIZATION:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_LEGACY:
        case PlanIdTypes.PRO_START_ORGANIZATION:
        case PlanIdTypes.PREMIUM_ORGANIZATION:
        case PlanIdTypes.PRO_SMS_ORGANIZATION:
            return { unit: 'MONTH', duration: 1, cyclesCount: 12 };
        case PlanIdTypes.PRO_ORGANIZATION_14:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_14:
        case PlanIdTypes.TRIAL:
            return { unit: 'DAY', duration: 14, cyclesCount: 1 };
        case PlanIdTypes.PRO_ORGANIZATION_30:
        case PlanIdTypes.PRO_SMS_ORGANIZATION_30:
        case PlanIdTypes.PREMIUM_ORGANIZATION_30:
            return { unit: 'DAY', duration: 30, cyclesCount: 1 };
        default:
            var exhaustiveCheck = planId;
            return null;
    }
};
exports.getPlanBillingCycleData = getPlanBillingCycleData;
